export default {
    // createRelease
    START_CREATE_RELEASE: "START_CREATE_RELEASE",
    CREATE_RELEASE_SUCCESS: "CREATE_RELEASE_SUCCESS",
    CREATE_RELEASE_FAILED: "CREATE_RELEASE_FAILED",
    // getPendingReviews
    GET_REVIEW_LIST_SUCCESS: "GET_REVIEW_LIST_SUCCESS",
    GET_REVIEW_LIST_FAILED: "GET_REVIEW_LIST_FAILED",
    START_GET_REVIEW_LIST: "START_GET_REVIEW_LIST",
    // getReleaseById
    START_GET_RELEASE_BY_ID: 'START_GET_RELEASE_BY_ID',
    GET_RELEASE_BY_ID_SUCCESS: 'GET_RELEASE_BY_ID_SUCCESS',
    GET_RELEASE_BY_ID_FAILED: 'GET_RELEASE_BY_ID_FAILED',
    // submitReviewForRelease
    START_SUBMIT_REVIEW_FOR_RELEASE: 'START_SUBMIT_REVIEW_FOR_RELEASE',
    SUBMIT_REVIEW_FOR_RELEASE_SUCCESS: 'SUBMIT_REVIEW_FOR_RELEASE_SUCCESS',
    SUBMIT_REVIEW_FOR_RELEASE_FAILED: 'SUBMIT_REVIEW_FOR_RELEASE_FAILED',
    // getAdminCommentsByApplicationForRelease
    START_ADMIN_COMMENTS_FOR_APPLICATION: 'START_ADMIN_COMMENTS_FOR_APPLICATION',
    GET_ADMIN_COMMENTS_FOR_APPLICATION_SUCCESS: 'ADMIN_COMMENTS_FOR_APPLICATION_SUCCESS',
    GET_ADMIN_COMMENTS_FOR_APPLICATION_FAILED: 'ADMIN_COMMENTS_FOR_APPLICATION_FAILED',
    // getReleasesForApplication
    START_GET_RELEASES_FOR_APP: 'START_GET_RELEASES_FOR_APP',
    GET_RELEASES_FOR_APP_SUCCESS: 'GET_RELEASES_FOR_APP_SUCCESS',
    GET_RELEASES_FOR_APP_FAILED: 'GET_RELEASES_FOR_APP_FAILED',
}